import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { SectionCard } from "@/components/shared/PageChrome";
import { StatusBadge } from "@/components/shared/StatusBadge";

const TYPE_LABELS = { ONBOARDING: "Onboarding submission", PROPERTY_CHANGE: "Property change", COMPLIANCE_UPDATE: "Compliance update", GENERAL: "General update" };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : null);

// The supplier's own submissions to Jigsaw (drafts, awaiting review, decided) - the existing /submissions/mine rows only.
export function ReviewQueue({ supplierId, onLoaded }) {
  const [state, setState] = useState({ loading: true, items: [] });
  useEffect(() => {
    api.get("/submissions/mine", { params: { supplier_id: supplierId } })
      .then((r) => { setState({ loading: false, items: r.data.items }); onLoaded?.(r.data.items); })
      .catch(() => setState({ loading: false, items: [], error: true }));
  }, [supplierId]); // eslint-disable-line react-hooks/exhaustive-deps
  const inReview = state.items.filter((s) => s.status === "SUBMITTED").length;
  return (
    <SectionCard title="Review queue" testId="supplier-review-queue" bodyClassName="px-5 pb-4"
      subtitle={state.loading ? "Loading…" : `${inReview} awaiting Jigsaw review · ${state.items.length} total`}
      action={<Link data-testid="supplier-review-queue-open" to="/supplier/submissions" className="text-[13px] text-jigsaw-link hover:underline">Open submissions</Link>}>
      {state.error && <p data-testid="supplier-review-queue-error" className="text-sm text-jigsaw-danger">Could not load your submissions.</p>}
      {!state.loading && !state.error && state.items.length === 0 && <p data-testid="supplier-review-queue-empty" className="text-sm text-jigsaw-muted">You have not sent anything to Jigsaw for review yet.</p>}
      {state.items.length > 0 && (
        <ol className="divide-y divide-jigsaw-border">
          {state.items.slice(0, 5).map((s) => (
            <li key={s.id} data-testid={`supplier-review-queue-${s.id}`} className="flex items-start justify-between gap-3 py-2.5">
              <div className="min-w-0">
                <p className="text-[13px] font-semibold text-jigsaw-navy">{TYPE_LABELS[s.submission_type] || s.submission_type.replace(/_/g, " ")}</p>
                <p className="font-mono-ref text-[11px] text-jigsaw-muted">{s.submitted_at ? `Submitted ${fmt(s.submitted_at)}` : `Draft · step ${s.step} · saved ${fmt(s.created_at)}`}</p>
              </div>
              <StatusBadge status={s.status} />
            </li>
          ))}
        </ol>
      )}
    </SectionCard>
  );
}
